import { useMutation, useQueryClient } from '@tanstack/react-query';
import { changePcmpProposalPaymentSource } from '../api/pcmpProposals.api';
import type { PcmpPaymentSourcePayload } from '../types/pcmpProposal.types';
import { pcmpProposalEditCallbacks } from '../utils/pcmpProposalEditCallbacks';

export function useChangePcmpPaymentSource(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpPaymentSourcePayload) =>
      changePcmpProposalPaymentSource(proposalId, payload),
    ...pcmpProposalEditCallbacks(queryClient, proposalId, 'Payment source changed', onSuccess),
  });
}
